module.exports = __webpack_public_path__ + "media/assets/images/category/FathersDay@2x-92dfa32b898e827892463f04e106c00d.png";